<template>
  <div :class="classObj" class="app-wrapper">
    <EnvironmentIndicator v-if="!isProduction" layout="main" />
    <div class="content-container" :class="{ 'is-collapsed': isCollapsed }">
      <DefaultSidebar
        class="sidebar-container"
        :is-collapsed.sync="isCollapsed"
      />
      <div class="main-container">
        <TopBar
          :is-collapse="isCollapsed"
          :is-onboarding-flow="isOnboardingFlow"
        />
        <Navbar />
        <AppMain />
        <AppFooter />
      </div>
      <MaskLayoutSidebar class="mask-layout-sidebar" />
    </div>
    <SitewideDialogs />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import AppMain from '@/components/AppMain'
import AppFooter from '@/components/AppFooter'
import DefaultSidebar from '@/components/DefaultSidebar'
import TopBar from '@/components/TopBar/index.vue'
import Navbar from '@/components/NavBar/index.vue'
import EnvironmentIndicator from '@/components/EnvironmentIndicator/index.vue'
import SitewideDialogs from '@/components/SitewideDialogs'
import MaskLayoutSidebar from '@/components/MaskLayout/MaskLayoutSidebar.vue'

export default {
  name: 'Layout',
  components: {
    EnvironmentIndicator,
    Navbar,
    AppMain,
    TopBar,
    DefaultSidebar,
    SitewideDialogs,
    MaskLayoutSidebar,
    AppFooter,
  },
  data() {
    return {
      isCollapsed: false,
    }
  },
  computed: {
    ...mapState({
      device: (state) => state.app.device,
    }),
    ...mapGetters('userProfile', { userProfile: 'profile' }),
    ...mapGetters('kyc', ['onboardingData']),
    classObj() {
      return {
        mobile: this.device === 'mobile',
        'ads-page':
          this.$route.path.startsWith('/ads') ||
          this.$route.path.startsWith('/farah'),
        'is-lavender': process.env.VUE_APP_IS_LAVENDER === 'true',
      }
    },
    isProduction() {
      return process.env.VUE_APP_ENV === 'production'
    },
    isKycUser() {
      return this.userProfile && this.userProfile.role === 'MERCHANT_KYC_USER'
    },
    isOnboardingFlow() {
      return this.isKycUser && this.onboardingData
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.app-wrapper {
  position: relative;
  width: fit-content;
  min-width: 100%;

  &::after {
    display: table;
    clear: both;
    content: '';
  }
}

.drawer-bg {
  position: absolute;
  top: 0;
  z-index: 888;
  width: 100%;
  height: 100%;
  background: #000;
  opacity: 0.3;
}

.content-container {
  // Start define variables =>>>
  --header-height: 77px;
  --sidebar-width: 242px;
  --sidebar-sub-merchant-item: 66px;
  --sidebar-zindex: 900;
  --sidebar-drawer-zindex: 700;
  --sidebar-drawer-width: 241px;
  --sidebar-head-height: var(--header-height) + var(--sidebar-sub-merchant-item);
  --sidebar-merchant-account-height: 66px;
  --main-content-zindex: 400;
  --topbar-zindex: 600;

  &.is-collapsed {
    --sidebar-width: 88px;
  }

  // <=== End define variables

  .sidebar-container {
    position: fixed;
    z-index: var(--sidebar-zindex);
    z-index: 1003;
    height: 100vh;
    transition: all 0.3s linear;
  }

  .main-container {
    z-index: var(--main-content-zindex);
    z-index: 1001;
    padding-top: var(--header-height);
    margin-inline-start: var(--sidebar-width);
  }

  .mask-layout-sidebar {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1002;
    background: rgba(0, 0, 0, 0.8);
  }
}
</style>
